__turbopack_context__.v({
  "homepage": "raKy6W_homepage",
  "marquee": "raKy6W_marquee",
});
